/**
 * 环境配置工具函数
 * 
 * 提供访问不同环境变量的便捷方法
 */

// 获取当前应用环境
export const getAppEnv = (): 'development' | 'test' | 'production' => {
  return import.meta.env.VITE_APP_ENV || 'development';
};

// 获取 API 基础 URL
export const getApiBaseUrl = (): string => {
  return import.meta.env.VITE_API_BASE_URL;
};

// 获取应用名称
export const getAppName = (): string => {
  return import.meta.env.VITE_APP_NAME || 'Gel Labs Console';
};

// 检查是否为调试模式
export const isDebugMode = (): boolean => {
  return import.meta.env.VITE_DEBUG === 'true';
};

// 检查是否为生产环境
export const isProduction = (): boolean => {
  return getAppEnv() === 'production';
};

// 检查是否为测试环境
export const isTestEnvironment = (): boolean => {
  return getAppEnv() === 'test';
};

// 检查是否为开发环境
export const isDevelopment = (): boolean => {
  return getAppEnv() === 'development';
};

// 使用全局常量（在 vite.config.ts 中定义）
export const ENV_CONFIG = {
  APP_ENV: __APP_ENV__,
  API_BASE_URL: __API_BASE_URL__,
  APP_NAME: __APP_NAME__,
  DEBUG: __DEBUG__,
} as const;

export default ENV_CONFIG;